module.exports = __webpack_public_path__ + "static/media/015-credit-card.e2dbe178.svg";